import * as React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Buttons from 'react-bootstrap/Button';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { CircularProgress, Paper, Slide } from '@mui/material';
import { useEffect } from 'react';
import '../RacingBusd/Dialog.css';
import { Link, useNavigate } from 'react-router-dom';
import Info from '../RacingBusd/Info/Info';




const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;


    return (
        <DialogTitle sx={{ m: 0, p: 2, background: 'linear-gradient(to right bottom, #4e4c4c, #4e4c4c)' }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};
const StyledPaper = styled(Paper)`

  max-width:780px!important;
`;

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};



const PositionDialog = ({ handleClose, open, myDog, raceNumber, title, sno }) => {
    const [loading, setLoading] = React.useState(true)
    const [AllData, setAllData] = React.useState([])
    const [newData, setNewData] = React.useState([])
    const [myPosition, setmyPosition] = React.useState(0)
    const [openInfo, setOpenInfo] = React.useState(false);

    useEffect(() => {
        let url = "";
        if (title == "busd") {
            console.log("inside busd");
            url = "https://backend.galarace.ai/api/v1/raceBUSD";
        } else {
            console.log("inside dsl");
            url = "https://backend.galarace.ai/api/v1/raceBUSD";

        }
        fetch(url, {
            headers: { "authorization": `Bearer bs2zDM01DMMEgt33CrKZt8x4abs2zDM01DMMEgt33Cr6atzL3CJdExpP4x4abs2zDM01DMMEgt33Cr` }
        })
            .then(res => res.json())
        .then(data => {setAllData(data?.data?.reverse());
          const newdatas=  data?.data?.reverse()
          setNewData(newdatas[raceNumber - 1]?.race);
        })
        // if (AllData) {
        //     setNewData(AllData[raceNumber - 1]?.race);
        //     // console.log(AllData[raceNumber - 1]?.race,"AllData[raceNumber - 1]?.race")
        // }
    }, [AllData])


    const handleClickOpenInfo = () => {
        setOpenInfo(true);
    };

    const handleCloseInfo = () => {
        setOpenInfo(false);
    };


    const onPageLoad = () => {
        setLoading(false);
    };

    useEffect(() => {
        if (document.readyState === 'complete') {
            onPageLoad();
        } else {
            window.addEventListener('load', onPageLoad);
            return () => window.removeEventListener('load', onPageLoad);
        }
    }, []);

    const navigate = useNavigate();

    const [timeZone, setTimeZone] = React.useState("");

    // const getPlaceTimeZone = async () => {
    //     // const response = await fetch('https://api.ipify.org?format=json');
    //     const response = await fetch('https://freegeoip.app/json/');
    //     const data = await response.json();
    //     const timeZone = data.country_code;
    //     return timeZone;
    // };

    useEffect(() => {
        // console.log(getPlaceTimeZone(), "getPlaceTimeZone")
        const date = new Date();
        const dateAsString = date.toString();
        const timezone = dateAsString.match(/\(([^\)]+)\)$/)[1];

        // console.log(timezone, "timezone");
        // var matches = timezone.match(/\b(\w)/g);
        // var abbreviations = matches.join('');
        // console.log("abbreviations", abbreviations);

        const string = timezone;
        const words = string.split(" ");
        let result = "";

        for (let i = 0; i < words.length; i++) {
            if (words[i] === "Time") {
                result += words[i];
            } else {
                result += words[i][0];
            }
        }

        setTimeZone(result)
    }, [])


    return (

        <div>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
                className='text-center text-sm-start '
                PaperComponent={StyledPaper}
                TransitionComponent={Transition}
            >
                {loading ? <div className='bg-dark d-flex align-items-center justify-content-center' style={{ height: '60vh' }}>
                    <CircularProgress color="inherit" />
                </div> : (<>
                    <BootstrapDialogTitle className='fw-bold text-white fs-4 pe-5 text-center' id="customized-dialog-title" onClose={handleClose}>
                        Race Results
                        <br />
                        {sno}
                    </BootstrapDialogTitle>
                    <DialogContent sx={{ background: 'linear-gradient(to right bottom, #4e4c4c, #4e4c4c)' }} className='border-white border-bottom-0 ' dividers>

                        <div className='time-show'>
                        <p className='text-center text-white'>Race Start Time: { newData?newData[0]?.date:""} {`(${timeZone})`}</p>
                        </div>

                        {/* <div className='d-flex justify-content-center'>
                            <button className='btn btn-info mx-auto text-white' style={{ background: "#006e7a" }} onClick={() => navigate("/replaysdsl", { state: { AllData: AllData1 } })}>REPLAY</button>
                        </div> */}

                        <div className='text-white mt-3 my-selection '>

                            {<p className='my-selection-wrapper'>Selected track : {AllData[raceNumber - 1]?.selectedDog?.track} <img alt='dog' className='dog  mx-1 dog-size mb-1' src={AllData[raceNumber - 1]?.selectedDog?.img}></img> {AllData[raceNumber - 1]?.selectedDog?.gender} <br /> Position is : {newData?.filter(res => res.img == AllData[raceNumber - 1]?.selectedDog?.img)[0]?.position} and have won {newData?.filter(res => res.img == AllData[raceNumber - 1]?.selectedDog?.img)[0]?.prize?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} GRT
                            </p>}
                        </div>

                        <p className='text-white my-2 text-center d-block d-md-none'>
                            <i class="fa-solid fa-less-than arrow"></i>
                            Scroll Sideways
                            <i class="fa-solid fa-greater-than arrow"></i>
                        </p>
                        <div className=" text-start table-responsive">
                            <table className="table table-borderless ">
                                <thead>
                                    <tr className='text-white mb-4 position-table-header'>
                                        <th scope="col">Position</th>
                                        <th scope="col">Track</th>
                                        <th scope="col">Horse</th>
                                        <th scope="col">Won</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                       newData?.length>0 && newData?.map((item, index) =>
                                            <tr className={`text-white position-table-body ${(AllData?.selectedDog?.img == item?.img) ? "grayanimation" : ""}`} key={index} style={{ backgroundColor: (AllData?.selectedDog?.img == item?.img) ? "gray" : "" }}>
                                                <td scope="row">{index + 1}
                                                </td>
                                                <td>
                                                    {item?.track}

                                                </td>
                                                <td className='text-start'>
                                                    <img src={item?.img} alt='dog' className='dog mb-2 dog-size d-block'></img> <span className='hideSm '>{item?.gender}</span><span className='hideLg text-start'>{item?.gender}</span>
                                                </td>
                                                <td>{item.prize?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} GRT <br />
                                                    {((item?.img == AllData?.selectedDog?.img) && index < 3 && <i onClick={handleClickOpenInfo} class="fas fa-info-circle text-white"></i>)}</td>
                                            </tr>
                                        )
                                    }

                                </tbody>
                            </table>
                        </div>
                        <div>

                        </div>

                    </DialogContent>
                    <Info
                        handleClose={handleCloseInfo}
                        open={openInfo}
                        setOpen={setOpenInfo}
                    ></Info>
                </>
                )}
            </BootstrapDialog>
        </div >

    );
};

export default PositionDialog;